import React from 'react';
import { ArrowRight } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      tag: 'MOST POPULAR',
      title: 'COMPLETE ONLINE LAUNCH',
      subtitle: 'DWA + BRANDING + SET-UP',
      description: 'Launch your done-for-you business with 1:1 Private 6 Month Mentorship + 6 Month Brand Growth.',
      features: [
        'Full access to Digital Wealth Academy',
        '6 months of 1:1 private mentorship',
        'Complete branding package',
        'Done-for-you business setup'
      ],
      price: '$1,500',
      originalPrice: '$2,000',
      link: 'https://stan.store/FarzeenDigitalWealth'
    },
    {
      tag: 'BEST VALUE',
      title: '1:1 DWA PRIVATE GUIDANCE',
      subtitle: 'Beginners Blueprint',
      description: 'Perfect for complete beginners. Start and grow a profitable online freedom-based business from zero.',
      features: [
        'Full DWA course access',
        'Private 1:1 coaching sessions',
        'Personalized business roadmap',
        'Direct mentor support'
      ],
      price: '$500',
      originalPrice: '$1,000',
      link: 'https://stan.store/FarzeenDigitalWealth'
    },
    {
      tag: 'ADVANCED',
      title: 'BRAND ELEVATION',
      subtitle: 'Strategic Marketing & Growth',
      description: 'Already have a business? Elevate your brand with custom strategic digital marketing expertise.',
      features: [
        'Custom digital marketing strategy',
        'Professional branding consultation',
        'Social media growth tactics',
        'Ongoing strategic support'
      ],
      price: '$2,000',
      originalPrice: null,
      link: 'https://stan.store/FarzeenDigitalWealth'
    }
  ];

  const additionalProducts = [
    { name: 'Complete Guide to Make Money with Digital Products', price: '$50', link: 'https://stan.store/FarzeenDigitalWealth/p/complete-guide-to-make-money-with-digital-products' },
    { name: 'DFY Stan Store Setup', price: '$150', originalPrice: '$200', link: 'https://stan.store/FarzeenDigitalWealth/p/dfy-stan-store-setup' },
    { name: 'Canva Crash Course', price: '$50', link: 'https://stan.store/FarzeenDigitalWealth/p/canva-crash-course--r4sq5je6' },
    { name: 'Custom Service/Product Development', price: '$100', link: 'https://stan.store/FarzeenDigitalWealth/p/custom-serviceproduct-development' }
  ];

  return (
    <section id="services" className="py-32" style={{ backgroundColor: '#ffffff' }}>
      <div className="container mx-auto px-8">
        {/* Header */}
        <div className="text-center mb-20 max-w-3xl mx-auto">
          <p className="text-xs tracking-[0.3em] mb-6 font-light" style={{ color: '#8b7355' }}>
            THE BREAK FREE & BUILD™ METHOD
          </p>
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-light leading-tight mb-6"
            style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
          >
            Choose Your
            <br />
            <span className="italic" style={{ color: '#8b7355' }}>Success Path</span>
          </h2>
          <p className="text-base font-light" style={{ color: '#666' }}>
            Personalized mentorship programs designed to help you build a thriving online business
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-24">
          {services.map((service, index) => (
            <div 
              key={index} 
              className={`p-8 border transition-all duration-300 hover:border-[#8b7355] ${
                index === 0 ? 'md:-mt-4 md:mb-4 border-[#8b7355]' : ''
              }`}
              style={{ borderColor: index === 0 ? '#8b7355' : 'rgba(0,0,0,0.1)' }}
            >
              {/* Tag */}
              <span 
                className="inline-block text-[10px] tracking-[0.2em] px-3 py-1 mb-6"
                style={{ backgroundColor: '#f8f6f3', color: '#8b7355' }}
              >
                {service.tag}
              </span>
              
              {/* Title */}
              <h3 className="text-lg font-light mb-1" style={{ color: '#1a1a1a' }}>
                {service.title}
              </h3>
              <p className="text-xs tracking-wide mb-4" style={{ color: '#8b7355' }}>
                {service.subtitle}
              </p>
              
              {/* Description */}
              <p className="text-sm font-light mb-6" style={{ color: '#666' }}>
                {service.description}
              </p>
              
              {/* Features */}
              <ul className="space-y-2 mb-8">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm font-light" style={{ color: '#666' }}>
                    <span style={{ color: '#8b7355' }}>—</span>
                    {feature}
                  </li>
                ))}
              </ul>
              
              {/* Price */}
              <div className="mb-6">
                <span className="text-2xl font-light" style={{ color: '#1a1a1a' }}>{service.price}</span>
                {service.originalPrice && (
                  <span className="ml-2 text-sm line-through" style={{ color: '#999' }}>{service.originalPrice}</span>
                )}
              </div>
              
              {/* CTA */}
              <a 
                href={service.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs tracking-[0.15em] transition-opacity hover:opacity-60"
                style={{ color: '#1a1a1a' }}
              >
                GET STARTED
                <ArrowRight size={14} strokeWidth={1.5} />
              </a>
            </div>
          ))}
        </div>

        {/* Additional Products */}
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h3 
              className="text-2xl md:text-3xl font-light"
              style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
            >
              Building Online? <span className="italic" style={{ color: '#8b7355' }}>Grab These</span>
            </h3>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {additionalProducts.map((product, index) => (
              <div 
                key={index}
                className="p-6 border transition-all duration-300 hover:border-[#8b7355] text-center"
                style={{ borderColor: 'rgba(0,0,0,0.1)' }}
              >
                <h4 className="text-sm font-light mb-4 leading-tight" style={{ color: '#1a1a1a' }}>
                  {product.name}
                </h4>
                <div className="mb-4">
                  <span className="text-xl font-light" style={{ color: '#8b7355' }}>{product.price}</span>
                  {product.originalPrice && (
                    <span className="ml-2 text-xs line-through" style={{ color: '#999' }}>{product.originalPrice}</span>
                  )}
                </div>
                <a 
                  href={product.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs tracking-[0.15em] transition-opacity hover:opacity-60"
                  style={{ color: '#1a1a1a' }}
                >
                  LEARN MORE
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
